import React, { useEffect, useState } from "react";
import ComingSoon from "../components/ComingSoon";
import BackWithBreadcrumbAppbar from "../components/BackWithBreadcrumbAppbar";
import { useTranslation } from "react-i18next";
import AgendaUI from "../components/AgendaUi";

const HydrogenProgram = () => {
  const { t } = useTranslation();
  const [agendaData, setAgendaData] = useState(null);

  useEffect(() => {
    fetch("/hydrogenProgram.json")
      .then((response) => response.json())
      .then((data) => setAgendaData(data))
      .catch((error) => console.error("Error loading hydrogen data:", error));
  }, []);

  if (!agendaData) return null;
  return (
    <>
      <BackWithBreadcrumbAppbar
        links={[{ label: t("dashboard"), href: "/" }]}
        currentPage={t("HydrogenWorkshopProgram")}
      />
      <AgendaUI data={agendaData} />
    </>
  );
};

export default HydrogenProgram;
